// v2.2.0 (2026-10-26): ภาพ 3D การไหลของไฟล์ แบบผังระบบ (architecture diagram) — พอร์ตจาก mockup TTNBCP-mockup/dashboard-3d-diagram.html
//   ส่วนกลาง TTNBCP.CLOUD = แผ่นบาง + ไอคอนแบน · เส้นบางหักมุมฉากมีหัวลูกศร · กรอบกลุ่มเส้นประ
//   ห้าง / ลูกค้า TTN / VAN อื่น = อาคารชุดเดิมของ v2.1.x (หันมุม 45° ให้เห็น 2 ด้าน) — มีอาคารใหม่ขึ้นอัตโนมัติทุกรายที่ backend ส่งมา
// ข้อมูลจริงจาก /api/flow (ไม่มีตัวเลขสุ่ม): เส้นทางทุกไฟล์จาก log Sort-EDI-Files, ผล Interface/PDF/Error จาก log parser / PDF-REPORT,
// อีเมลแจ้งเตือนจาก alert_log.json
//
// เส้นทาง (ตรงกับระบบจริง):
//   TUN  : ผู้ส่ง → รับไฟล์ → แยกผู้รับ → Interface (parser) → PDF → TUN   · TUN ที่มี interface ได้ TXT อีกก้อนจาก Interface
//   VAN  : ผู้ส่ง → รับไฟล์ → แยกผู้รับ → ConV2H → VANxxx
//   UNK  : ผู้ส่ง → รับไฟล์ → แยกผู้รับ → UNKNOW (ไม่ประมวลผลต่อ) → แจ้งเตือนอีเมล
//   Error: Interface / PDF / ConV2H → Error → แจ้งเตือนอีเมล
import * as THREE from 'three';

const ROWS = 11, T_ROWS = 15;   // v2.2.4: ลูกค้าเรียงคอลัมน์ละ 15 (ใช้ความสูงที่ว่าง แทนการแผ่ไปทางขวา — TTNBCP อยู่กึ่งกลางเสมอ)
//                  // อาคารต่อคอลัมน์ — เกินนี้ขึ้นคอลัมน์ใหม่ถัดออกไปด้านนอก (ป้ายอยู่ด้านนอกของอาคาร จึงเว้นช่องกว้าง)
const S_GAP = 3, T_GAP = 2.8, COL_GAP = 9.5, T_COL_GAP = 12.5;   // v2.2.4: คอลัมน์ลูกค้าห่างขึ้น ป้ายไม่ทับคอลัมน์ถัดไป
const SX0 = -19, TX0 = 17, TZ0 = -11;
const VANS = ['VANGEC', 'VANTIFFA', 'VANAIC'];
const VIEW_ISO = { th: 0.32, ph: 0.9, z: 1.1 };    // v2.2.1: มุมเฉียงเป็นค่าเริ่มต้น (ผู้ใช้สั่ง) — v2.2.0 เคยเป็นมุมตรง th 0 / ph 1.0
const VIEW_TOP = { th: 0, ph: 1.55, z: 1 };
const SPEED = 4.2;
const TILE = 2.1, TH = 0.3;
const SCALE = { sender: 0.85, tun: 0.72, van: 0.85 };   // ย่ออาคารให้พอดีระยะแถว (ลูกค้าสูงหลายชั้นย่อมากกว่า)

// สีของอาคาร (ชุดเดิม v2.1.x)
const BPAL = {
  light: { bldg: 0xf9fbfc, roof: 0xa8432f, tunRoof: 0x2f7d5b, txt: 0x3d6fa8, van: 0x5b5fa8, silver: 0xeef1f5, vglass: 0x5f9fe0,
    clay: 0xfbf8f2, claySh: 0xe4ddd0, clayPad: 0xf0eae0 },
  dark: { bldg: 0x4a525c, roof: 0xd0674f, tunRoof: 0x5bb38a, txt: 0x6f9fd8, van: 0x8f93e0, silver: 0x6b7480, vglass: 0x3f6f9c,
    clay: 0x4d4843, claySh: 0x38332e, clayPad: 0x302c28 },
};
// สีของผัง
const DPAL = {
  light: { tile: 0xffffff, edge: 0xcbd5e1, grp: 0xcbd5e1, path: 0x94a3b8, ring: 0x2563eb, icon: '#2563eb', iconBad: '#dc2626', iconWarn: '#d97706',
    ok: 0x2563eb, txt: 0x0ea5e9, vanP: 0x6366f1, unk: 0xd97706, err: 0xdc2626, mail: 0xea580c },
  dark: { tile: 0x161d28, edge: 0x2c3646, grp: 0x2c3646, path: 0x4a5568, ring: 0x6b9bff, icon: '#6b9bff', iconBad: '#f05252', iconWarn: '#f59e0b',
    ok: 0x6b9bff, txt: 0x38bdf8, vanP: 0x818cf8, unk: 0xf59e0b, err: 0xf05252, mail: 0xfb923c },
};

const STAGES = [
  ['IN', 'รับไฟล์', 'inbox', [-10.5, 0, 0]],
  ['SPLIT', 'แยกผู้รับ', 'split', [-4.5, 0, 0]],
  ['IF', 'Interface', 'code', [0.5, 0, -5.6]],
  ['PDF', 'PDF', 'doc', [5.5, 0, 0]],
  ['CONV', 'ConV2H', 'convert', [-4.5, 0, -21]],  // v2.2.4: บนสุดของ TTNBCP (z จริงตั้งตามแถว VAN) — เส้นไป VAN วิ่งด้านบน ไม่ผ่านกลุ่มลูกค้า
  ['UNK', 'UNKNOW', 'question', [-8.5, 0, -11]],  // v2.2.4: ขยับซ้ายให้พ้นเส้นแยกผู้รับ → ConV2H
  ['ERR', 'Error', 'alert', [5.5, 0, -11]],
  ['MAIL', 'แจ้งเตือนอีเมล', 'mail', [0.5, 0, -16.5]],
];

const isDark = () => document.documentElement.dataset.theme === 'dark';
const fmt = (n) => (n || 0).toLocaleString('en-US');

// ไอคอนแบนสีเดียว (วาดด้วย canvas ไม่พึ่งไฟล์ภายนอก)
function drawIcon(ctx, kind, col) {
  ctx.clearRect(0, 0, 256, 256); ctx.strokeStyle = col; ctx.fillStyle = col; ctx.lineWidth = 12; ctx.lineJoin = 'round'; ctx.lineCap = 'round';
  const R = (x, y, w, h, r = 10) => { ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h); };
  const L = (...p) => { ctx.beginPath(); ctx.moveTo(p[0], p[1]); for (let i = 2; i < p.length; i += 2) ctx.lineTo(p[i], p[i + 1]); ctx.stroke(); };
  const dot = (x, y, r) => { ctx.beginPath(); ctx.arc(x, y, r, 0, 7); ctx.fill(); };
  switch (kind) {
    case 'inbox': L(56, 150, 56, 196, 200, 196, 200, 150); L(56, 150, 96, 150, 108, 170, 148, 170, 160, 150, 200, 150); L(128, 52, 128, 128); L(100, 102, 128, 130, 156, 102); break;
    case 'split': L(56, 128, 112, 128); L(112, 128, 192, 72); L(112, 128, 192, 184); L(168, 66, 194, 70, 186, 96); L(168, 190, 194, 186, 186, 160); break;
    case 'code': L(98, 84, 54, 128, 98, 172); L(158, 84, 202, 128, 158, 172); L(140, 70, 116, 186); break;
    case 'doc': L(72, 48, 150, 48, 188, 86, 188, 208, 72, 208, 72, 48); L(150, 48, 150, 86, 188, 86); ctx.font = '700 44px sans-serif'; ctx.textAlign = 'center'; ctx.fillText('PDF', 130, 168); break;
    case 'convert': L(64, 100, 186, 100); L(162, 76, 188, 100, 162, 124); L(192, 156, 70, 156); L(94, 132, 68, 156, 94, 180); break;
    case 'question': ctx.beginPath(); ctx.arc(128, 128, 76, 0, 7); ctx.stroke(); ctx.beginPath(); ctx.arc(128, 106, 26, Math.PI, Math.PI * 2.4); ctx.stroke(); L(128, 140, 128, 150); dot(128, 176, 8); break;
    case 'alert': L(128, 50, 210, 196, 46, 196, 128, 50); L(128, 104, 128, 148); dot(128, 172, 8); break;
    case 'mail': R(52, 76, 152, 108, 8); ctx.stroke(); L(56, 82, 128, 138, 200, 82); break;
    default: break;
  }
}

export function createFlowScene(host, cb = {}) {
  const panelW = () => (host.clientWidth > 900 ? 320 : 0);
  const canvas = document.createElement('canvas');
  canvas.className = 'flow-canvas';
  host.appendChild(canvas);
  const labels = document.createElement('div');
  labels.className = 'flow-labels dg';
  host.appendChild(labels);

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });   // พื้นหลังโปร่ง ใช้สีของการ์ด
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  const scene = new THREE.Scene();
  const cam = new THREE.OrthographicCamera(-1, 1, 1, -1, -300, 300);

  // ---------- วัสดุ ----------
  const M = {};
  Object.keys(BPAL.light).forEach((k) => { M[k] = new THREE.MeshStandardMaterial({ roughness: 0.85, metalness: 0 }); });
  M.vglass.roughness = 0.2; M.vglass.emissive.setHex(0x0a2440);
  M.silver.roughness = 0.35; M.silver.metalness = 0.3;
  M.ifLamp = new THREE.MeshStandardMaterial({ color: 0x8fe0ff, emissive: 0x2fb3e6, emissiveIntensity: 0.9 });
  const D = {
    tile: new THREE.MeshLambertMaterial({ color: 0xffffff }), edge: new THREE.LineBasicMaterial({ color: 0xffffff }),
    grp: new THREE.LineDashedMaterial({ color: 0xffffff, dashSize: 0.5, gapSize: 0.35 }), path: new THREE.LineBasicMaterial({ color: 0xffffff }),
    arrow: new THREE.MeshBasicMaterial({ color: 0xffffff }), ring: new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.85 }),
  };
  const PK = {}; ['ok', 'txt', 'vanP', 'unk', 'err', 'mail'].forEach((k) => { PK[k] = new THREE.MeshBasicMaterial({ color: 0xffffff }); });
  const texMats = new Set();
  const iconTex = [];

  const hemi = new THREE.HemisphereLight(0xffffff, 0xd5dbe3, 0.85);
  scene.add(hemi);
  const sun = new THREE.DirectionalLight(0xffffff, 0.55);
  sun.position.set(-10, 30, 20); sun.castShadow = true; sun.shadow.mapSize.set(2048, 2048);
  Object.assign(sun.shadow.camera, { left: -60, right: 60, top: 60, bottom: -60, near: 1, far: 120 }); sun.shadow.bias = -0.0008; sun.shadow.radius = 6;
  scene.add(sun);
  // พื้นรับเงาอย่างเดียว (มองไม่เห็นพื้น เห็นแค่เงาอาคาร)
  const shadowM = new THREE.ShadowMaterial({ opacity: 0.12 });
  const ground = new THREE.Mesh(new THREE.PlaneGeometry(260, 200), shadowM);
  ground.rotation.x = -Math.PI / 2; ground.position.y = -0.005; ground.receiveShadow = true; scene.add(ground);

  let world = new THREE.Group(); scene.add(world);
  let pickables = [];

  // ---------- ตัวช่วยสร้างรูปทรง ----------
  const box = (w, h, d, mat, x, y, z, parent = world) => { const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat);
    m.position.set(x, y, z); m.castShadow = m.receiveShadow = true; parent.add(m); return m; };
  const ball = (r, mat, x, y, z, parent = world) => { const m = new THREE.Mesh(new THREE.SphereGeometry(r, 20, 12), mat);
    m.position.set(x, y, z); parent.add(m); return m; };
  const rshape = (w, d, r) => { const s = new THREE.Shape(), a = -w / 2, b = -d / 2;
    s.moveTo(a + r, b); s.lineTo(a + w - r, b); s.quadraticCurveTo(a + w, b, a + w, b + r); s.lineTo(a + w, b + d - r);
    s.quadraticCurveTo(a + w, b + d, a + w - r, b + d); s.lineTo(a + r, b + d); s.quadraticCurveTo(a, b + d, a, b + d - r);
    s.lineTo(a, b + r); s.quadraticCurveTo(a, b, a + r, b); return s; };
  const roundSlab = (w, d, r, h, mat, y, parent) => { const m = new THREE.Mesh(new THREE.ExtrudeGeometry(rshape(w, d, r), { depth: h, bevelEnabled: false, curveSegments: 10 }), mat);
    m.rotation.x = -Math.PI / 2; m.position.set(0, y, 0); m.castShadow = m.receiveShadow = true; parent.add(m); return m; };

  // ผิวตึกแบบหน้าต่าง (วาดลง canvas) — โหมดมืดเปิดไฟหน้าต่างด้วย emissiveMap
  const mkTex = (draw, w = 64, h = 64) => { const c = document.createElement('canvas'); c.width = w; c.height = h; draw(c.getContext('2d'));
    const t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; t.anisotropy = 4; return t; };
  const winTex = {
    frame: mkTex((x) => { x.fillStyle = '#f3f1ec'; x.fillRect(0, 0, 64, 64); const g = x.createLinearGradient(0, 10, 0, 56);
      g.addColorStop(0, '#9cc0e4'); g.addColorStop(1, '#4f7fb6'); x.fillStyle = g; x.fillRect(12, 10, 40, 44);
      x.fillStyle = 'rgba(255,255,255,.35)'; x.fillRect(12, 10, 40, 6); }),
    glass: mkTex((x) => { const g = x.createLinearGradient(0, 0, 64, 64); g.addColorStop(0, '#7fa9d6'); g.addColorStop(1, '#3f6fa6');
      x.fillStyle = g; x.fillRect(0, 0, 64, 64); x.fillStyle = 'rgba(235,242,250,.75)'; x.fillRect(0, 0, 64, 3); x.fillRect(0, 0, 3, 64); }),
    icore: mkTex((x) => { x.fillStyle = '#f4f7fa'; x.fillRect(0, 0, 64, 64); const g = x.createLinearGradient(0, 0, 0, 64);
      g.addColorStop(0, '#8fe0ff'); g.addColorStop(1, '#2fb3e6'); x.fillStyle = g; x.fillRect(6, 6, 52, 52); }),
    tglass: mkTex((x) => { const g = x.createLinearGradient(0, 0, 0, 64); g.addColorStop(0, '#5d8fc6'); g.addColorStop(1, '#2c5486');
      x.fillStyle = g; x.fillRect(0, 0, 64, 64); x.fillStyle = 'rgba(240,244,248,.9)'; x.fillRect(0, 0, 4, 64);
      x.fillStyle = 'rgba(240,244,248,.45)'; x.fillRect(0, 40, 64, 2); }),
  };
  const nightTex = (m) => { const d = isDark();
    m.color.setHex(d ? 0x8a96aa : 0xffffff); m.emissive.setHex(d ? 0x5c7aa8 : 0x000000); m.emissiveMap = d ? m.map : null;
    m.emissiveIntensity = d ? 0.65 : 0; m.needsUpdate = true; };
  function winTower(w, h, d, kind, x, z, y0, parent, rows) {
    const cell = kind === 'frame' ? 0.16 : kind === 'tglass' ? 0.3 : 0.2;
    const side = (len) => { const t = winTex[kind].clone(); t.needsUpdate = true;
      t.repeat.set(Math.max(1, Math.round(len / cell)), rows || Math.max(1, Math.round(h / cell)));
      const mt = new THREE.MeshStandardMaterial({ map: t, roughness: kind === 'glass' ? 0.3 : 0.7, metalness: kind === 'glass' ? 0.2 : 0 });
      texMats.add(mt); nightTex(mt); return mt; };
    const sx = side(d), sz = side(w);
    const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), [sx, sx, M.clay, M.clay, sz, sz]);
    m.position.set(x, y0 + h / 2, z); m.castShadow = m.receiveShadow = true; parent.add(m); return m;
  }
  function disposeTree(o) {
    o.traverse((c) => {
      if (c.geometry) c.geometry.dispose();
      [].concat(c.material || []).forEach((m) => { if (m.map && texMats.has(m)) { m.map.dispose(); m.dispose(); texMats.delete(m); } });
    });
  }
  function dropGroup(t) {
    if (t.parent) t.parent.remove(t);
    t.traverse((o) => { const i = pickables.indexOf(o); if (i >= 0) pickables.splice(i, 1); });
    disposeTree(t);
  }

  // ---------- อาคาร (ชุดเดิม v2.1.x) — สร้างในกลุ่มย่อย n.b ที่หมุน 45° และย่อตาม SCALE ----------
  const senderH = (n) => 1.6 + Math.min(1, Math.log2(1 + n.files) / 7) * 2.8;
  const floorsOf = (files) => 2 + Math.min(9, Math.round(Math.log2(1 + files) * 1.6));
  function buildSender(n) {
    const y1 = 0.46, H = senderH(n), first = n.tw == null;
    if (n.tw) dropGroup(n.tw);
    const t = n.tw = new THREE.Group(); n.b.add(t); n.H = H;
    winTower(0.8, H * 0.8, 0.8, 'glass', -0.45, -0.72, y1, t);
    winTower(0.8, H * 0.88, 0.8, 'glass', -0.45, 0.72, y1, t);
    winTower(1.3, H, 1.1, 'frame', 0.25, 0, y1, t);
    box(1.38, 0.1, 1.18, M.clay, 0.25, y1 + H + 0.05, 0, t);
    box(1.34, 0.06, 1.14, M.roof, 0.25, y1 + H - 0.04, 0, t);
    box(0.45, 0.2, 0.35, M.claySh, 0.1, y1 + H + 0.2, 0.15, t);
    if (!first) t.traverse((o) => { if (o.isMesh) pickables.push(o); });
    n.top = (y1 + H + 0.5) * n.sc;
  }
  function buildTun(n) {
    const F = floorsOf(n.files), first = n.tw == null, W = 2.1, Dp = 1.9, X = 0.1, FH = 0.42, G = 0.42, y0 = 0.06;
    if (n.tw) dropGroup(n.tw);
    const t = n.tw = new THREE.Group(); n.b.add(t); n.F = F;
    winTower(W - 0.5, G, Dp - 0.4, 'tglass', X, 0, y0, t, 1);
    [[-1, -1], [1, -1], [-1, 1], [1, 1], [0, 1], [0, -1]].forEach(([a, b]) => box(0.1, G, 0.1, M.clay, X + a * (W / 2 - 0.08), y0 + G / 2, b * (Dp / 2 - 0.08), t));
    const yb = y0 + G;
    winTower(W - 0.12, F * FH, Dp - 0.12, 'tglass', X, 0, yb, t, F);
    for (let i = 0; i <= F; i++) box(W + 0.1, 0.1, Dp + 0.1, M.clay, X, yb + i * FH + 0.05, 0, t);
    const cx = X + W / 2 + 0.22, ch = G + (F + 1) * FH;
    // ลูกค้าที่มี Interface TXT: แกนบันไดกระจกฟ้าสว่าง + ฝาและไฟบนยอดสีฟ้า
    winTower(0.72, ch, 0.8, n.iface ? 'icore' : 'glass', cx, 0.45, y0, t);
    box(0.8, 0.08, 0.88, n.iface ? M.txt : M.clay, cx, y0 + ch + 0.04, 0.45, t);
    if (n.iface) ball(0.1, M.ifLamp, cx, y0 + ch + 0.16, 0.45, t);
    const yr = yb + F * FH + 0.1;
    [(Dp + 0.1) / 2 - 0.03, -(Dp + 0.1) / 2 + 0.03].forEach((dz) => box(W + 0.1, 0.08, 0.06, M.tunRoof, X, yr + 0.04, dz, t));
    [(W + 0.1) / 2 - 0.03, -(W + 0.1) / 2 + 0.03].forEach((dx) => box(0.06, 0.08, Dp + 0.1, M.tunRoof, X + dx, yr + 0.04, 0, t));
    box(0.8, 0.35, 0.7, M.clay, X - 0.5, yr + 0.175, -0.45, t);
    [[0.1, -0.1], [0.76, -0.1], [0.1, 0.8], [0.76, 0.8]].forEach(([a, b]) => box(0.04, 0.4, 0.04, M.claySh, X + a, yr + 0.2, b, t));
    for (let k = 0; k < 4; k++) box(0.04, 0.04, 1.0, M.claySh, X + 0.1 + k * 0.22, yr + 0.42, 0.35, t);
    if (!first) t.traverse((o) => { if (o.isMesh) pickables.push(o); });
    n.top = (yr + 0.9) * n.sc;
  }
  function buildVan(n) {
    const F = floorsOf(n.files), W = 2.3, Dp = 2.1, R = 0.5, first = n.tw == null;
    if (n.tw) dropGroup(n.tw);
    const t = n.tw = new THREE.Group(); n.b.add(t); n.F = F;
    let y = 0.06;
    roundSlab(W - 0.12, Dp - 0.12, R - 0.06, 0.42, M.vglass, y, t); y += 0.42;
    for (let i = 0; i < F; i++) {
      roundSlab(W + 0.08, Dp + 0.08, R + 0.04, 0.025, M.van, y, t); y += 0.025;
      roundSlab(W + 0.08, Dp + 0.08, R + 0.04, 0.13, M.silver, y, t); y += 0.13;
      roundSlab(W - 0.1, Dp - 0.1, R - 0.05, 0.26, M.vglass, y, t); y += 0.26;
    }
    roundSlab(W + 0.08, Dp + 0.08, R + 0.04, 0.025, M.van, y, t); y += 0.025;
    roundSlab(W + 0.08, Dp + 0.08, R + 0.04, 0.16, M.silver, y, t); y += 0.16;
    if (!first) t.traverse((o) => { if (o.isMesh) pickables.push(o); });
    n.top = (y + 0.4) * n.sc;
  }

  // ---------- ขั้นตอนใน TTNBCP: แผ่นบาง + ไอคอนแบน ----------
  const tileGeo = (() => {
    const g = new THREE.ExtrudeGeometry(rshape(TILE, TILE, 0.28), { depth: TH, bevelEnabled: false, curveSegments: 6 });
    g.rotateX(-Math.PI / 2); return g;
  })();
  const tileEdge = new THREE.EdgesGeometry(tileGeo, 30);
  const iconGeo = new THREE.PlaneGeometry(1.45, 1.45).rotateX(-Math.PI / 2);
  function iconMat(kind, tone) {
    const cv = document.createElement('canvas'); cv.width = cv.height = 256;
    const tex = new THREE.CanvasTexture(cv); tex.anisotropy = 4;
    const mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false });
    iconTex.push({ cv, tex, kind, tone, mat }); return mat;
  }
  function buildStage(n, g) {
    const tile = new THREE.Mesh(tileGeo, D.tile); tile.receiveShadow = true; g.add(tile);
    g.add(new THREE.LineSegments(tileEdge, D.edge));
    const tone = n.id === 'ERR' ? 'bad' : n.id === 'UNK' || n.id === 'MAIL' ? 'warn' : 'accent';
    const ic = new THREE.Mesh(iconGeo, iconMat(n.icon, tone)); ic.position.y = TH + 0.01; g.add(ic);
    n.top = TH; n.half = TILE / 2;
  }

  // ---------- สถานะ ----------
  let N = {};               // id -> node
  let sig = '';             // ลายเซ็นของ layout (รายชื่ออาคาร) — เปลี่ยนเมื่อไรสร้างฉากใหม่
  let bounds = { x0: -26, x1: 34, z0: -14, z1: 20 };
  let fitU = 0.05;
  const HOME = new THREE.Vector3(4, 0, 2);
  const target = HOME.clone(), tTarget = HOME.clone();
  // v2.2.5: มุมบนเป็นค่าเริ่มต้น (ผู้ใช้สั่ง) · ภาพชิดซ้าย เหลือที่ว่างด้านขวาให้อาคารฝั่งรับที่เพิ่มเข้ามาเห็นทันที
  const VIEW0 = VIEW_TOP;
  const view = { th: VIEW0.th, ph: VIEW0.ph, z: VIEW0.z, tth: VIEW0.th, tph: VIEW0.ph, tz: VIEW0.z };
  { const q = new URLSearchParams(window.location.search).get('view');
    if (q) { const [a, b, c] = q.split(',').map(Number); if (!Number.isNaN(a)) view.th = view.tth = a; if (b) view.ph = view.tph = b; if (c) view.z = view.tz = c; } }
  let ring = null, groups = [];
  let sel = null;
  let playing = true, speed = 1, showLabels = true, showPk = true;
  const packets = [], envelopes = [], queue = [];
  let queueAcc = 0;
  let seenEv = new Set(), seenErr = new Set(), sentCount = -1, curDate = '';
  let data = null;
  const flashes = {};
  const pkGeo = new THREE.CylinderGeometry(0.2, 0.2, 0.08, 18);
  const mailGeo = new THREE.BoxGeometry(0.5, 0.06, 0.34);
  const ROUTE = {};

  const sid = (name) => (N[`S:${name}`] ? `S:${name}` : null);
  const tid = (name) => (N[`T:${name}`] ? `T:${name}` : null);
  const V3 = (id, y = 0.02) => new THREE.Vector3(N[id].pos[0], y, N[id].pos[2]);

  function clearPackets() {
    packets.forEach((p) => { world.remove(p.m); p.el.remove(); });
    packets.length = 0; queue.length = 0;
    envelopes.forEach((e) => scene.remove(e.m)); envelopes.length = 0;
  }

  // เส้นหักมุมฉาก: a → (bend, a.z) → (bend, b.z) → b · bend = จุดกึ่งกลาง หรือเลนที่กำหนด
  const ARW = new THREE.ShapeGeometry(new THREE.Shape([new THREE.Vector2(0, 0.32), new THREE.Vector2(-0.22, -0.12), new THREE.Vector2(0.22, -0.12)])).rotateX(-Math.PI / 2);
  // via = จุดหักที่กำหนดเอง [[x, z], ...] (ใช้แทน bend เมื่อเส้นต้องอ้อมเส้นอื่น)
  function route(a, b, bend, arrow = true, via = null) {
    const k = `${a}>${b}`; if (ROUTE[k]) return;
    const pa = V3(a), pb = V3(b), mx = bend != null ? bend : (pa.x + pb.x) / 2;
    const pts = via ? [pa, ...via.map(([x, z]) => new THREE.Vector3(x, 0.02, z)), pb]
      : Math.abs(pa.z - pb.z) < 0.01 ? [pa, pb]
        : Math.abs(pa.x - pb.x) < 0.01 ? [pa, pb]
          : [pa, new THREE.Vector3(mx, 0.02, pa.z), new THREE.Vector3(mx, 0.02, pb.z), pb];
    ROUTE[k] = pts;
    const cut = (p, q, d) => p.clone().add(q.clone().sub(p).setLength(d));
    const n = pts.length, vis = pts.map((p) => p.clone());
    vis[0] = cut(pts[0], pts[1], N[a].half + 0.05);
    vis[n - 1] = cut(pts[n - 1], pts[n - 2], N[b].half + (arrow ? 0.35 : 0.05));
    world.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(vis), D.path));
    if (arrow) {
      const tip = cut(pts[n - 1], pts[n - 2], N[b].half + 0.1), dir = pts[n - 1].clone().sub(pts[n - 2]);
      const ar = new THREE.Mesh(ARW, D.arrow); ar.position.copy(tip); ar.position.y = 0.03; ar.rotation.y = Math.atan2(dir.x, dir.z) - Math.PI; world.add(ar);
    }
  }
  // กรอบกลุ่มเส้นประมุมมน + ชื่อกลุ่ม
  function frame(name, x0, z0, x1, z1) {
    const r = 0.8, y = 0.01, pts = [];
    const arc = (cx, cz, a0) => { for (let i = 0; i <= 6; i++) { const a = a0 + i / 6 * Math.PI / 2; pts.push(new THREE.Vector3(cx + Math.cos(a) * r, y, cz + Math.sin(a) * r)); } };
    arc(x1 - r, z0 + r, -Math.PI / 2); arc(x1 - r, z1 - r, 0); arc(x0 + r, z1 - r, Math.PI / 2); arc(x0 + r, z0 + r, Math.PI); pts.push(pts[0].clone());
    const l = new THREE.Line(new THREE.BufferGeometry().setFromPoints(pts), D.grp); l.computeLineDistances(); world.add(l);
    const el = document.createElement('div'); el.className = 'flbl hub grp'; el.innerHTML = `<span class="n">${name}</span>`; labels.appendChild(el);
    groups.push({ el, pos: [x0 + 0.4, 0, z0 - 0.35], x0, z0, x1, z1 });
  }

  function buildWorld(d) {
    clearPackets();
    labels.innerHTML = '';
    Object.keys(pops).forEach((k) => delete pops[k]);
    Object.keys(ROUTE).forEach((k) => delete ROUTE[k]);
    iconTex.forEach((t) => { t.tex.dispose(); t.mat.dispose(); }); iconTex.length = 0;
    scene.remove(world); disposeTree(world);
    world = new THREE.Group(); scene.add(world); pickables = []; N = {}; groups = [];
    // ทุกรายที่ backend ส่งมามีอาคารของตัวเอง (ผู้ส่ง/ลูกค้าใหม่ขึ้นอาคารใหม่อัตโนมัติ — UNKNOW และ "ไม่ทราบ" ไม่มีอาคาร ตามที่ flow.py กรองไว้)
    // เรียงตามชื่อเพื่อให้ตำแหน่งคงที่ทั้งวัน — สร้างฉากใหม่เฉพาะตอนมีรายใหม่ · เกิน ROWS รายขึ้นคอลัมน์ถัดออกไปด้านนอก
    const senders = [...new Set(d.sender_order || [])].sort();
    const tuns = [...new Set(d.tun_order || [])].sort();
    const ifaceSet = new Set(d.interface_tuns || []);
    const tCols = Math.ceil(tuns.length / T_ROWS) || 1;
    const sRows = Math.min(ROWS, senders.length), tRows = Math.min(T_ROWS, tuns.length);
    // คอลัมน์ถัดไปเยื้องครึ่งแถว → เส้นจากคอลัมน์นอกลอดช่องระหว่างอาคารคอลัมน์ใน
    senders.forEach((s, i) => { const c = Math.floor(i / ROWS), r = i % ROWS;
      N[`S:${s}`] = { id: `S:${s}`, key: s, kind: 'sender', name: s, side: -1, pos: [SX0 - c * COL_GAP, 0, (r - (sRows - 1) / 2) * S_GAP + (c % 2) * S_GAP / 2], files: 0 }; });
    tuns.forEach((t, i) => { const c = Math.floor(i / T_ROWS), r = i % T_ROWS;
      N[`T:${t}`] = { id: `T:${t}`, key: t, kind: 'tun', name: t, side: 1, pos: [TX0 + c * T_COL_GAP, 0, TZ0 + r * T_GAP + (c % 2) * T_GAP / 2], files: 0, iface: ifaceSet.has(t) }; });
    const tz1 = TZ0 + Math.max(0, tRows - 1) * T_GAP + (tCols > 1 ? T_GAP / 2 : 0);
    // v2.2.4: กลุ่ม VAN อื่นอยู่เหนือกลุ่มลูกค้าเสมอ (ตำแหน่งคงที่ ไม่เลื่อนตามจำนวนลูกค้า) · ConV2H อยู่แนวเดียวกับ VAN แรก
    const VX = TX0, vz0 = TZ0 - 3.2 - 1.8 - (VANS.length - 1) * T_GAP;
    VANS.forEach((v, i) => { N[`V:${v}`] = { id: `V:${v}`, key: v, kind: 'van', name: v, side: 1, pos: [VX, 0, vz0 + i * T_GAP], files: 0 }; });
    STAGES.forEach(([id, name, icon, pos]) => { N[id] = { id, kind: 'stage', name, icon, pos: id === 'CONV' ? [pos[0], 0, vz0] : pos, done: 0 }; });

    Object.values(N).forEach((n) => {
      const g = new THREE.Group(); g.position.set(...n.pos); g.userData.id = n.id; world.add(g); n.g = g;
      if (n.kind === 'stage') { buildStage(n, g); }
      else {
        // กลุ่มย่อยหมุน 45° (เห็น 2 ด้าน + หลังคา ขณะที่ผังยังตรง) และย่อให้พอดีระยะแถว · ไฟกระพริบรับไฟล์ขยายกลุ่มนอก
        n.sc = SCALE[n.kind]; n.half = (n.kind === 'sender' ? 1.75 : n.kind === 'tun' ? 1.6 : 1.45) * n.sc;
        const b = n.b = new THREE.Group(); b.rotation.y = -Math.PI / 4; b.scale.setScalar(n.sc); g.add(b);
        if (n.kind === 'sender') {
          box(3.4, 0.06, 2.9, M.clayPad, 0, 0.03, 0, b); box(2.6, 0.3, 2.2, M.claySh, 0, 0.21, 0, b);
          for (let k = 0; k < 6; k++) { box(0.1, 0.3, 0.1, M.clay, -1.25 + k * 0.5, 0.21, 1.1, b); box(0.1, 0.3, 0.1, M.clay, 1.3, 0.21, -1.0 + k * 0.4, b); }
          box(2.9, 0.1, 2.5, M.clay, 0, 0.41, 0, b);
          buildSender(n);
        } else if (n.kind === 'tun') { box(3.0, 0.06, 2.6, M.clayPad, 0.1, 0.03, 0, b); buildTun(n); }
        else { roundSlab(2.7, 2.5, 0.6, 0.06, M.clayPad, 0, b); buildVan(n); }
      }
      g.traverse((o) => { if (o.isMesh) pickables.push(o); });
    });

    // เส้นทาง — เลนแนวตั้งของแต่ละกลุ่มอยู่ในช่องว่างระหว่างคอลัมน์ ไม่ลากผ่านอาคาร
    const nodes = Object.values(N);
    const S_BUS = SX0 + 4.5, PDF_BUS = TX0 - 3.2, IF_BUS = TX0 - 4.2, VAN_BUS = VX - 4.4, CE_BUS = N.ERR.pos[0] + 2.2;
    nodes.filter((n) => n.kind === 'sender').forEach((n) => route(n.id, 'IN', S_BUS));
    // แยกผู้รับ → ConV2H = เส้นตรงขึ้นด้านบน · UNKNOW แยกออกซ้ายจากเส้นเดียวกัน · UNKNOW → อีเมล ขึ้นแล้วเลี้ยวขวา (ตัดเส้นหลัก 1 จุด)
    const UZ = N.UNK.pos[2] + 3.8, MZ = N.MAIL.pos[2];
    route('IN', 'SPLIT'); route('SPLIT', 'IF'); route('IF', 'PDF'); route('SPLIT', 'CONV');
    route('SPLIT', 'UNK', null, true, [[N.SPLIT.pos[0], UZ], [N.UNK.pos[0], UZ]]);
    route('UNK', 'MAIL', null, true, [[N.UNK.pos[0], MZ]]);
    route('PDF', 'ERR'); route('IF', 'ERR'); route('ERR', 'MAIL'); route('CONV', 'ERR', CE_BUS);
    nodes.filter((n) => n.kind === 'tun').forEach((n) => { route('PDF', n.id, PDF_BUS); if (n.iface) route('IF', n.id, IF_BUS); });
    nodes.filter((n) => n.kind === 'van').forEach((n) => route('CONV', n.id, VAN_BUS));

    // กรอบกลุ่ม
    const xs = (k) => nodes.filter((n) => n.kind === k).map((n) => n.pos[0]), zs = (k) => nodes.filter((n) => n.kind === k).map((n) => n.pos[2]);
    if (senders.length) frame('ห้างผู้ส่ง', Math.min(...xs('sender')) - 8.5, Math.min(...zs('sender')) - 2, SX0 + 2.2, Math.max(...zs('sender')) + 2);
    frame('TTNBCP.CLOUD', -13, vz0 - 2.6, CE_BUS + 1, 3.6);
    if (tuns.length) frame('ลูกค้า TTN (VANTTN)', TX0 - 2.2, TZ0 - 2, Math.max(...xs('tun')) + 7, tz1 + 2);
    frame('VAN อื่น', VX - 2.2, vz0 - 1.8, VX + 7.5, vz0 + (VANS.length - 1) * T_GAP + 1.8);

    ring = new THREE.Mesh(new THREE.RingGeometry(1.25, 1.42, 48), D.ring);
    ring.rotation.x = -Math.PI / 2; ring.position.y = 0.03; ring.visible = false; world.add(ring);

    // ป้ายชื่อ: ห้าง/ลูกค้า/VAN = บรรทัดเดียวด้านนอกอาคาร · ขั้นตอน = ใต้แผ่น
    nodes.forEach((n) => {
      const el = document.createElement('div');
      el.className = `flbl ${n.kind}${n.id === 'ERR' ? ' errn' : n.id === 'UNK' ? ' unkn' : ''}${n.kind === 'stage' ? '' : ' fixed'}`;
      const nm = document.createElement('span'); nm.className = 'n'; nm.textContent = n.name;
      const c = document.createElement('span'); c.className = 'c';
      el.append(nm, c); el.onclick = () => select(n.id); labels.appendChild(el); n.el = el; n.cEl = c;
    });

    // ขอบเขตภาพ → จุดกึ่งกลาง + ขนาดพอดี (คิดที่มุมเริ่มต้น)
    bounds = { x0: Math.min(...groups.map((g) => g.x0)), x1: Math.max(...groups.map((g) => g.x1)), z0: Math.min(...groups.map((g) => g.z0)) - 1, z1: Math.max(...groups.map((g) => g.z1)) };
    computeFit();   // คำนวณขนาด + HOME (ชิดซ้าย)
    target.copy(HOME); tTarget.copy(HOME);
    layout();   // v2.2.4: ใช้ขนาดพอดีทันที (เดิมรอ resize → ข้อมูลมาทีหลังภาพยังซูมค้างที่ค่าเริ่มต้น)
    sel = null; if (cb.onSelect) cb.onSelect(null);
    applyTheme();
  }

  function computeFit() {
    // v2.2.5: มุมบน — ซูมให้เห็นทั้งภาพ (ไม่ย่อเกิน ~11 px/หน่วย ป้ายยังอ่านได้) แล้ววางขอบซ้ายของภาพชิดซ้ายของการ์ด
    // ภาพแคบกว่าการ์ด → เหลือที่ว่างด้านขวาให้อาคารลูกค้าที่เพิ่มขึ้น · ภาพกว้าง/สูงเกิน → ล้นไปทางขวา/ล่าง ลากซ้ายเพื่อเลื่อนดู
    const W = Math.max(200, host.clientWidth - panelW()), H = Math.max(200, host.clientHeight);
    const cw = bounds.x1 - bounds.x0, ch = (bounds.z1 - bounds.z0) * Math.sin(VIEW0.ph);
    const u = Math.min(Math.max(cw / (W - 24), ch / (H - 24)) * 1.02, 1 / 11);
    fitU = u * VIEW0.z;
    const ox = (host.clientWidth - panelW()) / 2, oy = H / 2, m = 14;
    HOME.x = bounds.x0 + (ox - m) * u;                                   // ขอบซ้ายภาพ = ขอบซ้ายการ์ด + 14px
    HOME.z = ch / u <= H - 2 * m ? (bounds.z0 + bounds.z1) / 2           // สูงพอ → กึ่งกลางแนวตั้ง
      : bounds.z0 + ((oy - m) * u) / Math.sin(VIEW0.ph);                 // สูงเกิน → ชิดบน
  }

  function layout() {
    const W = host.clientWidth, H = host.clientHeight;
    if (!W || !H) return;
    renderer.setSize(W, H, false);
    const u = fitU / view.z, pw = panelW();
    const ox = (W - pw) / 2, oy = H / 2;
    cam.left = -ox * u; cam.right = (W - ox) * u; cam.top = oy * u; cam.bottom = -(H - oy) * u;
    cam.updateProjectionMatrix();
  }
  function placeCam() {
    const r = 120;
    cam.position.set(target.x + r * Math.cos(view.ph) * Math.sin(view.th), r * Math.sin(view.ph), target.z + r * Math.cos(view.ph) * Math.cos(view.th));
    cam.up.set(0, 1, 0); cam.lookAt(target);
  }

  // ---------- โหมดสี (ตาม data-theme ของแอป) ----------
  function applyTheme() {
    const dk = isDark(), bp = BPAL[dk ? 'dark' : 'light'], dp = DPAL[dk ? 'dark' : 'light'];
    Object.keys(bp).forEach((k) => M[k].color.setHex(bp[k]));
    D.tile.color.setHex(dp.tile); D.edge.color.setHex(dp.edge); D.grp.color.setHex(dp.grp); D.path.color.setHex(dp.path); D.arrow.color.setHex(dp.path); D.ring.color.setHex(dp.ring);
    PK.ok.color.setHex(dp.ok); PK.txt.color.setHex(dp.txt); PK.vanP.color.setHex(dp.vanP); PK.unk.color.setHex(dp.unk); PK.err.color.setHex(dp.err); PK.mail.color.setHex(dp.mail);
    iconTex.forEach((t) => { drawIcon(t.cv.getContext('2d'), t.kind, t.tone === 'bad' ? dp.iconBad : t.tone === 'warn' ? dp.iconWarn : dp.icon); t.tex.needsUpdate = true; });
    hemi.intensity = dk ? 0.7 : 0.85; sun.intensity = dk ? 0.45 : 0.55; hemi.groundColor.setHex(dk ? 0x0b0f15 : 0xd5dbe3);
    shadowM.opacity = dk ? 0.35 : 0.12;
    texMats.forEach(nightTex);
  }
  const themeObs = new MutationObserver(applyTheme);
  themeObs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

  // ---------- เมาส์ ----------
  let down = null, dragged = false;
  const onCtx = (e) => e.preventDefault();
  const rel = (e) => { const r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width, h: r.height }; };
  const ray = new THREE.Raycaster(), mv = new THREE.Vector2();
  function hit(e) {
    const q = rel(e); mv.set(q.x / q.w * 2 - 1, -q.y / q.h * 2 + 1); ray.setFromCamera(mv, cam);
    const h = ray.intersectObjects(pickables)[0]; if (!h) return null;
    let o = h.object; while (o && !o.userData.id) o = o.parent; return o && o.userData.id;
  }
  // v2.2.3: คลิกซ้ายลาก = เลื่อน (ผู้ใช้สั่ง) · คลิกขวาลาก หรือ Shift+ลาก = หมุน (เดิมกลับกัน)
  const onDown = (e) => { down = { x: e.clientX, y: e.clientY, pan: !(e.button === 2 || e.shiftKey) }; dragged = false; canvas.setPointerCapture(e.pointerId); };
  const onMove = (e) => {
    if (!down) { canvas.style.cursor = hit(e) ? 'pointer' : ''; return; }
    const dx = e.clientX - down.x, dy = e.clientY - down.y;
    if (!dragged && Math.hypot(dx, dy) > 4) { dragged = true; canvas.classList.add('drag'); }
    if (!dragged) return;
    if (down.pan) {
      const u = (cam.top - cam.bottom) / host.clientHeight, s = Math.sin(view.th), c = Math.cos(view.th);
      // v2.2.5: แก้ทิศแนวตั้งกลับด้าน (เดิมลากขึ้นแล้วภาพเลื่อนลง) — ภาพเลื่อนตามเมาส์ทั้งสองแกน
      tTarget.x -= (c * dx + s * dy / Math.sin(view.ph)) * u; tTarget.z -= (-s * dx + c * dy / Math.sin(view.ph)) * u;
      tTarget.x = Math.max(bounds.x0, Math.min(bounds.x1, tTarget.x)); tTarget.z = Math.max(bounds.z0, Math.min(bounds.z1, tTarget.z));
    } else {
      view.tth -= dx * 0.006; view.tph = Math.min(1.55, Math.max(0.3, view.tph + dy * 0.004));
      if (cb.onView) cb.onView(null);
    }
    down.x = e.clientX; down.y = e.clientY;
  };
  const onUp = (e) => { canvas.classList.remove('drag'); if (down && !dragged) select(hit(e)); down = null; };
  // ซูมด้วย Ctrl/⌘ + ล้อ — ล้อเฉย ๆ ให้เลื่อนหน้าเว็บตามปกติ
  const onWheel = (e) => { if (!e.ctrlKey && !e.metaKey) return; e.preventDefault(); view.tz = Math.min(4, Math.max(0.6, view.tz * Math.exp(-e.deltaY * 0.0012))); };
  canvas.addEventListener('contextmenu', onCtx);
  canvas.addEventListener('pointerdown', onDown);
  canvas.addEventListener('pointermove', onMove);
  canvas.addEventListener('pointerup', onUp);
  canvas.addEventListener('wheel', onWheel, { passive: false });
  const ro = new ResizeObserver(() => { computeFit(); layout(); });
  ro.observe(host);

  function select(id) {
    sel = id && N[id] ? id : null;
    Object.values(N).forEach((n) => n.el && n.el.classList.toggle('sel', n.id === sel));
    if (ring) { ring.visible = !!sel; if (sel) { const n = N[sel]; ring.position.x = n.pos[0]; ring.position.z = n.pos[2]; ring.scale.setScalar(Math.max(0.85, n.half / 1.15)); } }
    if (cb.onSelect) cb.onSelect(sel ? { id: sel, kind: N[sel].kind, key: N[sel].key } : null);
  }

  // ---------- ไฟล์ที่วิ่ง: จุดสีตามเส้นทาง + ป้ายเลข interchange ----------
  function makePacket(o) {
    // ต่อเส้นทางทีละช่วงตามโหนด · nodeD[i] = ระยะที่ถึงโหนดที่ i
    const pts = [], nodeD = [0];
    let L = 0;
    for (let i = 0; i < o.ids.length - 1; i++) {
      const seg = ROUTE[`${o.ids[i]}>${o.ids[i + 1]}`] || [V3(o.ids[i]), V3(o.ids[i + 1])];
      for (let j = i > 0 ? 1 : 0; j < seg.length; j++) { if (pts.length) L += pts[pts.length - 1].distanceTo(seg[j]); pts.push(seg[j]); }
      nodeD.push(L);
    }
    const cum = [0]; for (let i = 1; i < pts.length; i++) cum.push(cum[i - 1] + pts[i].distanceTo(pts[i - 1]));
    const mat = o.route === 'mail' ? PK.mail : o.route === 'unk' ? PK.unk : o.route === 'van' ? PK.vanP : o.route === 'err' ? PK.err : o.child ? PK.txt : PK.ok;
    const m = new THREE.Mesh(o.route === 'mail' ? mailGeo : pkGeo, mat); m.position.copy(pts[0]); m.position.y = 0.08; world.add(m);
    const p = { pts, cum, nodeD, d: 0, k: 0, s: 0, m, ...o };
    p.el = document.createElement('div');
    p.el.className = `fpk${o.child ? ' txt' : ''}${o.route !== 'tun' ? ` ${o.route}` : ''}`;
    p.el.textContent = o.label;
    p.el.title = o.title || '';
    p.el.onclick = () => { if (cb.onPacket && o.ev) cb.onPacket(o.ev); else if (o.selectId) select(o.selectId); };
    labels.appendChild(p.el);
    packets.push(p); return p;
  }
  // ป้ายบนกล่อง = เลข interchange (UNB) · ถ้าอ่านไม่ได้ (ไฟล์เกิน retention) ใช้ชื่อไฟล์แบบย่อ
  const shortRef = (ev) => ev.ref || (ev.file ? (ev.file.length > 22 ? `${ev.file.slice(0, 20)}…` : ev.file) : '');
  function spawnEvent(ev) {
    // ผู้ส่งที่ไม่มีอาคาร ("ไม่ทราบ") → กล่องเริ่มวิ่งที่ "รับไฟล์"
    const s0 = sid(ev.sender), s = s0 || 'IN';
    const head = (ids) => (s0 ? ids : ids.slice(1));
    const label = shortRef(ev), title = `${ev.sender} → ${ev.dest} · ${ev.file}`;
    if (ev.route === 'tun') {
      const t = tid(ev.dest); if (!t) return;
      makePacket({ ids: head([s, 'IN', 'SPLIT', 'IF', 'PDF', t]), route: 'tun', label, title, ev, iface: N[t].iface });
    } else if (ev.route === 'van') {
      const v = `V:${ev.dest}`; if (!N[v]) return;
      makePacket({ ids: head([s, 'IN', 'SPLIT', 'CONV', v]), route: 'van', label, title, ev });
    } else if (ev.route === 'unk') {
      makePacket({ ids: head([s, 'IN', 'SPLIT', 'UNK']), route: 'unk', label: `${label} ?`, title: `${ev.sender} → UNKNOW (receiver ${ev.receiver || '-'})`, selectId: 'UNK',
        mail: data && data.alerts && data.alerts.enabled });
    } else {
      if (!s0) return;
      makePacket({ ids: [s, 'IN'], route: 'unk', label: `${label} ✕`, title: `Sort ผิดพลาด: ${ev.file}`, selectId: 'IN' });
    }
  }
  function spawnError(er) {
    const from = er.kind === 'pdf' ? 'PDF' : er.kind === 'conv' ? 'CONV' : 'IF';
    makePacket({ ids: [from, 'ERR'], route: 'err', label: `${er.ref || er.tun} ✕`, title: er.kind === 'conv' ? `ConV2H ${er.tun} ผิดพลาด · ${er.file}` : `${er.sender} → ${er.tun} · ${er.kind === 'pdf' ? 'PDF' : 'Interface'} ผิดพลาด`, selectId: 'ERR',
      mail: data && data.alerts && data.alerts.enabled });
  }
  function stepPacket(p, dt) {
    if (p.done) return;
    p.d += dt * SPEED;
    while (p.k < p.ids.length - 1 && p.d >= p.nodeD[p.k + 1]) { p.k++; reach(p, p.ids[p.k]); if (p.done) return; }
    while (p.s < p.cum.length - 2 && p.d >= p.cum[p.s + 1]) p.s++;
    const a = p.pts[p.s], b = p.pts[p.s + 1], f = Math.min(1, (p.d - p.cum[p.s]) / ((p.cum[p.s + 1] - p.cum[p.s]) || 1));
    p.m.position.lerpVectors(a, b, f); p.m.position.y = 0.08;
  }
  function reach(p, id) {
    flashes[id] = 1;
    if (id === 'IF' && p.iface) {
      makePacket({ ids: ['IF', p.ids[p.ids.length - 1]], route: 'tun', child: true, label: `${p.label} TXT`, title: p.title, ev: p.ev });
    }
    if (p.k === p.ids.length - 1) {
      p.done = true; world.remove(p.m); p.el.remove();
      if ((p.route === 'tun' || p.route === 'van') && !p.child) bump(id);   // ไฟล์ถึงลูกค้า/VAN → +n เด้ง
      if (p.route === 'unk' && p.mail && p.ids[p.ids.length - 1] === 'UNK') makePacket({ ids: ['UNK', 'MAIL'], route: 'mail', label: `${p.label.replace(' ?', '')} ✉`, title: 'ส่งต่อให้แจ้งเตือนอีเมล (UNKNOW)', selectId: 'MAIL' });
      if (p.route === 'err' && p.mail) makePacket({ ids: ['ERR', 'MAIL'], route: 'mail', label: `${p.label.replace(' ✕', '')} ✉`, title: 'ส่งต่อให้แจ้งเตือนอีเมล', selectId: 'MAIL' });
    }
  }
  function sendEnvelope() {
    if (!N.MAIL) return;
    flashes.MAIL = 1;
    const e = new THREE.Mesh(mailGeo, PK.mail); e.position.set(N.MAIL.pos[0], 0.6, N.MAIL.pos[2]); scene.add(e); envelopes.push({ m: e, t: 0 });
  }

  // ---------- ข้อมูลจาก /api/flow ----------
  function setData(d, opts = {}) {
    data = d;
    const s = JSON.stringify([[...new Set(d.sender_order || [])].sort(), [...new Set(d.tun_order || [])].sort(), d.interface_tuns]);
    const dateChanged = d.date !== curDate;
    if (s !== sig || dateChanged) {
      sig = s; buildWorld(d);
      if (dateChanged) { curDate = d.date; seenEv = new Set(); seenErr = new Set(); sentCount = -1; }
    }
    // ตัวเลขบนอาคาร
    const ss = d.senders || {};
    Object.values(N).forEach((n) => {
      if (n.kind === 'sender') n.files = ss[n.key] || 0;
      else if (n.kind === 'tun') { const t = (d.tuns || {})[n.key] || {}; n.files = t.files || 0; n.err = t.error || 0;
      } else if (n.kind === 'van') n.files = (d.vans || {})[n.key] || 0;
    });
    const tsum = Object.values(d.tuns || {});
    const evs = d.events || [];
    N.IN.done = evs.length; N.SPLIT.done = evs.length;
    N.IF.done = tsum.reduce((a, t) => a + t.interface + t.handoff, 0); N.IF.ifc = tsum.reduce((a, t) => a + t.interface, 0);
    N.PDF.done = tsum.reduce((a, t) => a + t.pdf, 0);
    N.CONV.done = Object.values(d.vans || {}).reduce((a, v) => a + v, 0);
    N.ERR.done = (d.errors || []).length;
    N.UNK.done = ((d.unknown || {}).today || []).length; N.UNK.pending = (d.unknown || {}).pending || 0;
    N.MAIL.done = ((d.alerts || {}).sent || []).length; N.MAIL.enabled = !!(d.alerts || {}).enabled;
    N.MAIL.pending = (d.errors || []).filter((r) => !r.mailed).length + ((d.alerts || {}).pending_unknown || 0);
    Object.values(N).forEach((n) => {
      if (n.kind === 'sender' && Math.abs(senderH(n) - n.H) > 0.05) buildSender(n);
      if (n.kind === 'tun' && floorsOf(n.files) !== n.F) buildTun(n);
      if (n.kind === 'van' && floorsOf(n.files) !== n.F) buildVan(n);
    });
    updateLabelText();

    // เหตุการณ์ใหม่ → ไฟล์วิ่ง
    const evKey = (e) => `${e.t}|${e.file}|${e.dest}`;
    const erKey = (e) => `${e.t}|${e.tun}|${e.file}|${e.kind}`;
    const first = seenEv.size === 0 && seenErr.size === 0 && sentCount < 0;
    const newEv = evs.filter((e) => !seenEv.has(evKey(e)));
    const newEr = (d.errors || []).filter((e) => !seenErr.has(erKey(e)));
    newEv.forEach((e) => seenEv.add(evKey(e)));
    newEr.forEach((e) => seenErr.add(erKey(e)));
    if (first) {
      // เปิดหน้าครั้งแรก: เล่นไฟล์ล่าสุดไม่กี่ไฟล์ให้เห็นการไหล (เฉพาะวันนี้)
      if (opts.live) evs.slice(-6).forEach((e) => queue.push({ kind: 'ev', e }));
    } else {
      newEv.sort((a, b) => a.t.localeCompare(b.t)).forEach((e) => queue.push({ kind: 'ev', e }));
      newEr.forEach((e) => queue.push({ kind: 'err', e }));
    }
    const sc = ((d.alerts || {}).sent || []).length;
    if (sentCount >= 0 && sc > sentCount) for (let i = sentCount; i < sc; i++) queue.push({ kind: 'mail' });
    sentCount = sc;
  }
  function updateLabelText() {
    Object.values(N).forEach((n) => {
      let t;
      if (n.kind === 'sender' || n.kind === 'van') t = `${fmt(n.files)} ไฟล์`;
      else if (n.kind === 'tun') t = `${fmt(n.files)} ไฟล์${n.err ? ` · ผิด ${n.err}` : ''}`;
      else if (n.id === 'IF') t = `TXT ${fmt(n.ifc)} · ส่งต่อ ${fmt(n.done - n.ifc)}`;
      else if (n.id === 'PDF') t = `${fmt(n.done)} ใบ`;
      else if (n.id === 'ERR') t = `${fmt(n.done)} รายการ`;
      else if (n.id === 'UNK') t = `วันนี้ ${fmt(n.done)} · ค้าง ${fmt(n.pending)}`;
      else if (n.id === 'MAIL') t = n.enabled ? `ส่งแล้ว ${fmt(n.done)} ฉบับ${n.pending ? ` · รอ ${n.pending}` : ''}` : 'ปิดการแจ้งเตือน';
      else t = `${fmt(n.done)} ไฟล์`;
      if (n.cEl && n.cEl.textContent !== t) n.cEl.textContent = t;
    });
  }
  function replay() {
    // ย้อนดูทั้งวัน: เล่นทุกไฟล์ของวันตามลำดับเวลา (เร่งความเร็ว)
    if (!data) return;
    clearPackets();
    (data.events || []).forEach((e) => queue.push({ kind: 'ev', e, fast: true }));
    (data.errors || []).slice().reverse().forEach((e) => queue.push({ kind: 'err', e, fast: true }));
  }

  // ---------- ป้าย +n: เด้งขึ้นเมื่อไฟล์ถึงลูกค้า/VAN (ถึงติด ๆ กันนับรวม) แล้วยุบลงหายเข้าไปในอาคาร ----------
  const pops = {};
  function bump(id) {
    const n = N[id]; if (!n || (n.kind !== 'tun' && n.kind !== 'van')) return;
    let q = pops[id];
    if (!q) {
      // 2 ชั้น: ชั้นนอกจัดตำแหน่ง (transform) ชั้นในเด้ง/ยุบ (scale) — ไม่ให้ scale คูณระยะ translate
      const el = document.createElement('div'); el.className = 'fpop'; const b = document.createElement('span'); b.className = `b ${n.kind}`;
      el.appendChild(b); labels.appendChild(el);
      q = pops[id] = { el, b, count: 0, t: 0 };
    }
    if (q.b.classList.contains('out')) q.count = 0;   // ไฟล์มาระหว่างกำลังยุบ → เริ่มนับรอบใหม่
    q.count += 1; q.t = 0;
    q.b.textContent = `+${q.count}`;
    q.b.classList.remove('go', 'out'); void q.b.offsetWidth; q.b.classList.add('go');
  }
  function stepPops(dt, put) {
    Object.keys(pops).forEach((id) => {
      const q = pops[id], n = N[id];
      q.t += dt;
      if (!n || q.t > 1.85) { q.el.remove(); delete pops[id]; return; }
      if (q.t > 1.4 && !q.b.classList.contains('out')) { q.b.classList.remove('go'); q.b.classList.add('out'); }   // ไม่มีไฟล์เพิ่ม 1.4 วิ → ยุบ
      put(q.el, n.pos[0], n.top + 0.25, n.pos[2]);
    });
  }

  // ป้ายผู้ส่ง / ลูกค้า / VAN แบบตายตัว: บรรทัดเดียวด้านนอกอาคาร (ผู้ส่ง = ซ้าย, ลูกค้า/VAN = ขวา) · หมุนกล้องกลับด้าน → ย้ายข้าง
  // ป้ายขั้นตอน: ใต้แผ่น (แยกผู้รับมีเส้นลงไป ConV2H ตรงกลาง → ป้ายเฉียงขวาล่าง ไม่ทับเส้น)
  // ป้ายด้านข้าง: ชื่อก่อนตัวเลขเสมอ · ไม่ล้นขอบซ้ายของภาพ
  function placeLabels(W, H) {
    const proj = (x, y, z) => { v3.set(x, y, z).project(cam); return [(v3.x + 1) / 2 * W, (1 - v3.y) / 2 * H]; };
    Object.values(N).forEach((n) => {
      if (!n.el) return;
      if (n.kind === 'stage') {
        const sp = n.id === 'SPLIT';
        const [x, y] = proj(n.pos[0] + (sp ? TILE / 2 - 0.35 : 0), 0, n.pos[2] + TILE / 2 + 0.15);
        n.el.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) translate(${sp ? '0' : '-50%'}, 2px)`;
        n.el.classList.toggle('left', sp);
        return;
      }
      const a = proj(n.pos[0] + n.side * (n.half + 0.3), 0, n.pos[2]), c = proj(n.pos[0], 0, n.pos[2]);
      const away = (a[0] - c[0]) * n.side >= 0;
      const right = away ? n.side > 0 : n.side < 0;
      const x = right ? a[0] : Math.max(a[0], (n.el.offsetWidth || 0) + 4);
      n.el.style.transform = `translate(${x.toFixed(1)}px, ${a[1].toFixed(1)}px) translate(${right ? '0' : '-100%'}, -50%)`;
    });
    groups.forEach((g) => { const [x, y] = proj(...g.pos); g.el.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) translate(0, -100%)`; });
  }

  // ---------- วนวาด ----------
  const v3 = new THREE.Vector3(), clock = new THREE.Clock();
  let raf = 0, alive = true;
  function tick() {
    if (!alive) return;
    // จำกัด dt ที่ 0.25 วิ — แท็บที่วาดได้น้อยเฟรมยังเดินเวลาถูก แต่สลับแท็บกลับมาไม่กระโดดไกล
    const dt = Math.min(clock.getDelta(), 0.25), ldt = playing ? dt * speed : 0;
    view.th += (view.tth - view.th) * 0.12; view.ph += (view.tph - view.ph) * 0.12;
    if (Math.abs(view.tz - view.z) > 0.001) { view.z += (view.tz - view.z) * 0.15; layout(); }
    target.lerp(tTarget, 0.15); placeCam();
    if (playing && queue.length) {
      queueAcc += ldt;
      const gapS = queue[0].fast ? 0.35 : 0.6;
      while (queue.length && queueAcc >= gapS && packets.filter((p) => !p.done).length < 60) {
        queueAcc -= gapS; const q = queue.shift();
        if (q.kind === 'ev') spawnEvent(q.e); else if (q.kind === 'err') spawnError(q.e); else sendEnvelope();
      }
    } else queueAcc = 0;
    packets.forEach((p) => stepPacket(p, ldt));
    for (let i = packets.length - 1; i >= 0; i--) if (packets[i].done) packets.splice(i, 1);
    for (let i = envelopes.length - 1; i >= 0; i--) { const e = envelopes[i]; e.t += dt;
      e.m.position.y = 0.6 + e.t * 2.4; e.m.rotation.y += dt * 3; e.m.scale.setScalar(Math.max(0.01, 1 - e.t / 1.6));
      if (e.t > 1.6) { scene.remove(e.m); envelopes.splice(i, 1); } }
    Object.keys(flashes).forEach((id) => { const n = N[id]; flashes[id] -= dt * 2.5;
      if (!n) { delete flashes[id]; return; }
      const s = 1 + Math.max(0, flashes[id]) * 0.06; n.g.scale.set(s, 1, s); if (flashes[id] <= 0) { n.g.scale.set(1, 1, 1); delete flashes[id]; } });
    if (ring && ring.visible) ring.material.opacity = 0.6 + Math.sin(performance.now() / 300) * 0.25;   // วงเลือกกระพริบเบา ๆ
    renderer.render(scene, cam);
    // ป้าย
    const W = host.clientWidth, H = host.clientHeight;
    const put = (el, x, y, z) => { v3.set(x, y, z).project(cam); el.style.transform = `translate(${((v3.x + 1) / 2 * W).toFixed(1)}px, ${((1 - v3.y) / 2 * H).toFixed(1)}px) translate(-50%, -100%)`; };
    placeLabels(W, H);
    stepPops(dt, put);
    packets.forEach((p) => {
      // ซ่อนป้ายกล่องตอนใกล้โหนด (ไม่ทับป้ายชื่อ)
      const near = (p.k > 0 && p.d - p.nodeD[p.k] < 1.6) || (p.k < p.nodeD.length - 2 && p.nodeD[p.k + 1] - p.d < 1.6);
      p.el.style.visibility = near ? 'hidden' : '';
      put(p.el, p.m.position.x, 0.5, p.m.position.z);
    });
    raf = requestAnimationFrame(tick);
  }
  layout();
  raf = requestAnimationFrame(tick);

  return {
    setData,
    select,
    replay,
    setPlaying(v) { playing = v; },
    setSpeed(v) { speed = v; },
    setLabels(v) { showLabels = v; labels.classList.toggle('hide-names', !showLabels); },
    setPacketLabels(v) { showPk = v; labels.classList.toggle('hide-pk', !showPk); },
    view(kind) {
      if (kind === 'iso') { view.tth = VIEW_ISO.th; view.tph = VIEW_ISO.ph; view.tz = VIEW_ISO.z; }
      else if (kind === 'top') { view.tth = VIEW_TOP.th; view.tph = VIEW_TOP.ph; view.tz = VIEW_TOP.z; }
      else if (kind === 'center') { tTarget.copy(HOME); view.tz = VIEW0.z; }
    },
    // v2.2.6: ปุ่มซูมเข้า/ออก (ขั้นละ 1.25 เท่า ช่วงเดียวกับ Ctrl+ล้อเมาส์ 0.6–4)
    zoom(f) { view.tz = Math.min(4, Math.max(0.6, view.tz * f)); },
    dispose() {
      alive = false; cancelAnimationFrame(raf);
      themeObs.disconnect(); ro.disconnect();
      canvas.removeEventListener('contextmenu', onCtx); canvas.removeEventListener('pointerdown', onDown);
      canvas.removeEventListener('pointermove', onMove); canvas.removeEventListener('pointerup', onUp); canvas.removeEventListener('wheel', onWheel);
      clearPackets(); disposeTree(scene); renderer.dispose();
      canvas.remove(); labels.remove();
    },
  };
}
